<template>
	<div class="studyCenter bg-[#F5F7FA]">
		<Header :current="4"></Header>
		<div class="userInfo mt-[20px] mb-[20px]">
			<div v-if="JSON.stringify(userInfo)!='{}'"
				class="2xl:max-w-7xl xl:max-w-7xl lg:container md:container flex align-items-center mx-auto py-[22px] box-border">
				<el-image class="w-[64px] h-[64px] mr-[14px] rounded-[50px]" :src="userInfo.avatar"
					fit="cover"></el-image>
				<div class="">
					<div class="text-[28px] font-bold mb-[6px]">
						{{userInfo.username}}
					</div>
					<div class="">
						ID:{{userInfo.email || userInfo.mobile}}
					</div>
				</div>
			</div>
		</div>
		<div class="2xl:max-w-7xl xl:max-w-7xl lg:container md:container mx-auto mb-[100px] flex ">
			<div :class="[lang=='en'?'w-[340px] ':'w-[240px] ']"
				class="w-[240px]  min-h-[600px] bg-white rounded-[6px] py-[20px] pr-[50px] pl-[30px] mr-[16px] box-border">
				<div @click="navClick(item,index)"
					:class="[lang=='en'?'min-h-[54px] py-[10px]':'h-[54px]', navIndex==index?'text-[#F5F5F5]  bg-[#2979FF]  active rounded-l-md':'text-[#686C73]']"
					v-for="(item,index) in navList" :key="index"
					class="no-underline navItem   relative cursor-pointer flex items-center  pl-[20px]  box-border  text-[16px]  block    box-borderw-full">
					<img :src="navIndex==index?item.imgSrcActive:item.imgSrc" class="w-[24px] h-[24px] mr-[14px]" alt=""
						srcset="" />
					<div class="flex-1  text-right whitespace-nowrap pr-[10px] box-border">
						{{item.title}}
					</div>
				</div>
			</div>
			<div class="flex-1 ">

				<!-- <div class=" mb-[10px] bg-white rounded-md   box-border  py-[20px] box-border  px-[57px] flex items-center justify-between">
					<div class="w-[50%] flex flex-col items-center">
						<div class=" text-[22px]">
							sdd分钟
						</div>
						<div class=" text-[13px]">
							今日学习时长
						</div>
					</div>
					<div class="w-[50%] flex flex-col items-center">
						<div class="text-[22px]">
							2天
						</div>
						<div class="text-[13px]">
							距离考试倒计时
						</div>
					</div>
				</div> -->
				<div class="bg-white rounded-md  p-[18px] box-border">
					<router-view></router-view>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import { EventBus } from '../../js/event-bus.js';
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {

				noticeText: '',
				noticeBarShow: false,

				navIndex: 0,
				userInfo: {},

				navList: [{
						imgSrc: require('../../static/image/icon48.png'),
						imgSrcActive: require('../../static/image/icon48Active.png'),
						title: '', //我的通知
						path: '/personalCenter/notice/newSystem?type=1'
					},
					{
						imgSrc: require('../../static/image/icon49.png'),
						imgSrcActive: require('../../static/image/icon49Active.png'),
						title: '', //我的购物车
						path: '/personalCenter/cart'
					},
					{
						imgSrc: require('../../static/image/icon50.png'),
						imgSrcActive: require('../../static/image/icon50Active.png'),
						title: '', //我的订单
						path: '/personalCenter/orderList'
					},
					{
						imgSrc: require('../../static/image/icon31.png'),
						imgSrcActive: require('../../static/image/icon31Active.png'),
						title: '', //学习中心
						// path: '/studyCenter/study/videosCourse?type=0'
						path: '/studyCenter/newStudyCenter'
					},
					{
						imgSrc: require('../../static/image/icon51.png'),
						imgSrcActive: require('../../static/image/icon51Active.png'),
						title: '', //我的收藏
						path: '/personalCenter/myCollect/courseCollect?type=0'
					}, {
						imgSrc: require('../../static/image/icon52.png'),
						imgSrcActive: require('../../static/image/icon52Active.png'),
						title: '', //我的问答
						path: '/personalCenter/myQA'
					},
					{
						imgSrc: require('../../static/image/icon53.png'),
						imgSrcActive: require('../../static/image/icon53Active.png'),
						title: '', //个人设置
						path: '/personalCenter/personalSet/baseInfo?type=0'
					},
					{
						imgSrc: require('../../static/image/icon54.png'),
						imgSrcActive: require('../../static/image/icon54Active.png'),
						title: '', //修改密码
						path: '/personalCenter/updatePass'
					},

				],

				lang: '',
				langInfo: {},
			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				console.log(to.fullPath); // 获取查询参数
				// 你可以在这里处理查询参数的变化


				if (to.fullPath.indexOf('personalCenter/notice') > -1) {
					this.navIndex = 0
				} else if (to.fullPath.indexOf('personalCenter/cart') > -1) {
					this.navIndex = 1
				} else if (to.fullPath.indexOf('personalCenter/orderList') > -1) {
					this.navIndex = 2
				} else if (to.fullPath.indexOf('studyCenter/newStudyCenter') > -1) {
					this.navIndex = 3
				} else if (to.fullPath.indexOf('personalCenter/myCollect') > -1) {
					this.navIndex = 4
				} else if (to.fullPath.indexOf('personalCenter/myQA') > -1) {
					this.navIndex = 5
				} else if (to.fullPath.indexOf('personalCenter/personalSet') > -1) {
					this.navIndex = 6
				} else if (to.fullPath.indexOf('updatePass') > -1) {
					this.navIndex = 7
				}
			}
		},
		mounted() {
			this.lang = localStorage.getItem('lang') || 'zh'
			if (this.$route.fullPath.indexOf('personalCenter/notice') > -1) {
				this.navIndex = 0
			} else if (this.$route.fullPath.indexOf('personalCenter/cart') > -1) {
				this.navIndex = 1
			} else if (this.$route.fullPath.indexOf('personalCenter/orderList') > -1) {
				this.navIndex = 2
			} else if (this.$route.fullPath.indexOf('studyCenter/newStudyCenter') > -1) {
				this.navIndex = 3
			} else if (this.$route.fullPath.indexOf('personalCenter/myCollect') > -1) {
				this.navIndex = 4
			} else if (this.$route.fullPath.indexOf('personalCenter/myQA') > -1) {
				this.navIndex = 5
			} else if (this.$route.fullPath.indexOf('personalCenter/personalSet') > -1) {
				this.navIndex = 6
			} else if (this.$route.fullPath.indexOf('personalCenter/updatePass') > -1) {
				this.navIndex = 7
			}


			if (localStorage.getItem('userInfo')) {
				this.userInfo = JSON.parse(localStorage.getItem('userInfo'))

				
			}

			if (localStorage.getItem('token') && !localStorage.getItem('userInfo')) {
				this.getUserInfo()
			}

			EventBus.$on('userInfo', (res) => {
				console.log("res========");
				console.log(res);
				this.userInfo = res
			})


			this.getdict_data()

		},

		methods: {

			getcheckCoursePermission() {
				this.$api.checkCoursePermission({}).then((res) => {
					if (res.data.has_permission == 0) {
						const lastTime = Number(localStorage.getItem('lastAdTime'))

						const isExitNoticeShow = localStorage.getItem('isExitNoticeShow')

						const currentTime = Date.now();
						const halfHourInMs = 180000;

						 if (isExitNoticeShow == 1){

							if (lastTime && ((currentTime - lastTime) > halfHourInMs)) {

								this.noticeBarShow = true
								setTimeout(() => {
									this.noticeBarShow  = false
								}, 30 * 1000)
								localStorage.setItem('lastAdTime', Date.now())

							} else if (!lastTime) {

								this.noticeBarShow = true

								setTimeout(() => {
									this.noticeBarShow  = false
								}, 30 * 1000)
								localStorage.setItem('lastAdTime', Date.now())
							}
						}

					}
				}).catch((error) => {})
			},

			getUserInfo() {
				this.$api.user_info().then((res) => {
					console.log(res.data);
					this.userInfo = res.data

			

					localStorage.setItem('userInfo', JSON.stringify(res.data))
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			setNav() {
				this.navList[0].title = this.langInfo.study_my_notice
				this.navList[1].title = this.langInfo.study_my_cart
				this.navList[2].title = this.langInfo.study_my_order
				this.navList[3].title = this.langInfo.study_center
				this.navList[4].title = this.langInfo.study_my_fav
				this.navList[5].title = this.langInfo.study_my_answer
				this.navList[6].title = this.langInfo.study_my_set
				this.navList[7].title = this.langInfo.study_password
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					
					this.noticeText=this.langInfo['New user prompt']
					
					this.setNav()
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			navClick(item, index) {
				console.log("item.path===" + item);
				console.log(item);
				if (item.path) {
					if (this.$route.fullPath === item.path) {
						// 如果相同则不进行导航
						return;
					}
					this.navIndex = index


					this.$router.push(item.path); // 使用完整路径
				}
			}

		}
	}
</script>

<style scoped>
	.userInfo {
		background-image: url('../../static/image/index06.png');
		background-size: 100% 230px;
		background-repeat: no-repeat;
	}

	.navItem.active::after {
		position: absolute;
		content: '';
		width: 40px;
		height: 100%;
		background-image: url('@/static/image/icon56.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		/* 	border-top: 27px solid transparent;
		/* 透明顶部 */
		/* border-bottom: 27px solid transparent; */
		/* 透明底部 */
		/* border-left: 27px solid #2979FF; */
		/* 右侧边为三角形的一部分 */
		position: absolute;
		/* 根据需要定位 */
		right: -40px;
	}
</style>